import './App.css';
import React, {useState, useRef, useEffect} from 'react';
import ThreeAnim from './ThreeAnim';
import logo from './assets/graphics/logo.svg';
import northPointer from './assets/graphics/north-pointer.svg';
import iconLoading from './assets/graphics/icon_loading_arrow.png';

import PopupInfo from "./PopupInfo";
import PopupInfoMulti from "./PopupInfoMulti";
//INPUT START
//TEMP

//INPUT END

function App() {

    const typeVilla = useRef(true);
    const typeLot = useRef(true);
    const waterFront = useRef(false);
    const openOceanView = useRef(false);
    const bayView = useRef(false);
    const available = useRef(false);
    const notAvailable = useRef(false);
    const reserved = useRef(false);
    const sold = useRef(false);

    const [isMenuOpen, setIsMenuOpen] = useState(true);

    let itemInfoCache = useRef({});



    const sliderValueMin = 0;
    const sliderValueMax = 2000000;
    const [sceneFilter, setSceneFilter] = useState({
        types: ["villa"],
        minPrice: sliderValueMin,
        maxPrice: sliderValueMax,
        status: ["available"],
        waterFront: waterFront.current,
        oceanView: openOceanView.current,
        bayView: bayView.current,
    });

    const [isLoading, setIsLoading] = useState(true);



    useEffect(() => {
        // Simulate loading resources like API calls, assets, etc.
        const simulateLoading = setTimeout(() => {
            if(threeAnimRef.current !== null || undefined) {
                if(threeAnimRef.current.loadComplete === true) {
                    setIsLoading(false); // Set loading to false after resources are "loaded"
                }
            }
        }, 1000);

        return () => clearTimeout(simulateLoading);
    }, []);


    useEffect(()=>{
        async function getProjectData() {
            try {
                // Fetch the .txt file
                const response = await fetch(process.env.REACT_APP_API_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ _id: process.env.REACT_APP_PROJECT_ID })
                });
                // Parse the response as JSON
                //console.log(response);
                const result = await response.json();

                // Log the parsed JavaScript object
                await setProjectData(result.project);

                for(let i = 0; i < result.project.units.length; i++) {
                    itemInfoCache.current[result.project.units[i].name] = result.project.units[i];
                    //Get stuff

                    itemInfoCache.current[result.project.units[i].name].media = result.project.units[i].media;//galleryImages.split(",");
                    //itemInfoCache.current[result.project.units[i].name].media.unshift(result.project.units[i].mainImage);

                    //add http if missing
                    for(let j = 0; j < itemInfoCache.current[result.project.units[i].name].media.length; j++){
                        if (!itemInfoCache.current[result.project.units[i].name].media[j].startsWith("http://") && !itemInfoCache.current[result.project.units[i].name].media[j].startsWith("https://")) {
                            itemInfoCache.current[result.project.units[i].name].media[j] = "http://" + itemInfoCache.current[result.project.units[i].name].media[j];
                        }
                    }

                    //console.log(result.project.units[i].name, result.project.units[i].galleryImages);
                }
                updateSceneFilter();
                resetAllFilters();
            } catch (error) {
                console.error('Error:', error);
            }
        }

        getProjectData().then(()=>{
            resetAllFilters();
        });

        //Mobile prevent elastic refresh
        const preventPullToRefresh = (event) => {
            if (window.scrollY === 0) {
                //event.preventDefault();
            }
        };

        document.addEventListener("touchmove", preventPullToRefresh, { passive: false });

        //Avoid first load issues with aspect ratio query
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 100); // Small delay ensures the browser has fully rendered

        return () => {
            document.removeEventListener("touchmove", preventPullToRefresh);
        };
    }, []);

//tooltip
    const tooltipRef = useRef(null);  // Ref to tooltip div
    const tooltipState = useRef({ on: false, x: 0, y: 0, src: "", text: "" });
    const [tooltipVisible, setTooltipVisible] = useState(false); // Only re-renders when `on` changes

    useEffect(() => {
        if (tooltipState.current.on && tooltipRef.current) {
            const tooltipEl = tooltipRef.current;

            // Get tooltip dimensions
            const tooltipWidth = tooltipEl.offsetWidth;
            const tooltipHeight = tooltipEl.offsetHeight;

            // Center the tooltip by subtracting half of its width & height
            tooltipEl.style.left = `${tooltipState.current.x - tooltipWidth / 2}px`;
            tooltipEl.style.top = `${tooltipState.current.y - tooltipHeight * 1.4}px`;
        }
    }, [tooltipVisible]); // Only updates when visibility changes


    async function onTooltipActivated(newTooltip) {
        tooltipState.current = newTooltip;  // Updates tooltip data (NO re-render)
        setTooltipVisible(newTooltip.on);   // Triggers re-render when showing/hiding tooltip
    }

    //

    function updateSceneFilter() {
        let newFilter = {
            types: [],
            minPrice: minPrice.current,
            maxPrice: maxPrice.current,
            status: [],
            waterFront: waterFront.current,
            oceanView: openOceanView.current,
            bayView: bayView.current,
        };

        let types = [];
        if (typeVilla.current === true) {
            types.push("villa");
        }
        if (typeLot.current === true) {
            types.push("lot");
        }
        if(types.length === 0) {
            //types.push("lot");
            //types.push("villa");
        }
        newFilter.types = types;

        let status = [];
        if (available.current === true) {
            status.push("available");
        }
        if (notAvailable.current === true) {
            status.push("not available");
        }
        if (sold.current === true) {
            status.push("sold");
        }
        if (reserved.current === true) {
            status.push("reserved");
        }
        if(status.length === 0) {
            status.push("available");
            status.push("not available");
            status.push("sold");
            status.push("reserved");
        }

        newFilter.status = status;

        setSceneFilter(newFilter);
    }

    const [popupOn, setPopupOn] = useState(false);
    const [popupMultiOn, setPopupMultiOn] = useState(false);
    const [projectData, setProjectData] = useState(null);
    const [popupInfo, setPopupInfo] = useState({
        name: "00",
        displayName: "Lot 00",
        mainImage: "",
        galleryImages: "",
        type: "Villa",
        totalPrice: 0,
        pricePerSqm: 0,
        interiorArea: 0,
        exteriorArea: 0,
        totalArea: 0,
        status: "available",
        waterFront: true,
        oceanView: true,
        bayView: true,
        numberOfBedrooms: 3,
        numberOfBathrooms: 2,
        numberOfParkingSpaces: 2,
        level: 0,
        description: "EMPTY",
        hoaFees: 0,
        media: []
    });
    const [popupInfoMulti, setPopupInfoMulti] = useState([]);

    //STATUS

    const toggleAvailable = () => {
        available.current = !available.current;
        updateSceneFilter();
    };
    const toggleSold = () => {
        sold.current = !sold.current;
        updateSceneFilter();
    };
    const toggleNotAvailable = () => {
        notAvailable.current = !notAvailable.current;
        updateSceneFilter();
    };
    const toggleReserved = () => {
        reserved.current = !reserved.current;
        updateSceneFilter();
    };
    //

    const threeAnimRef = useRef(null);


    function toggleTypeLot() {
        if(typeLot.current === false) {
            typeLot.current = true;
        } else {
            typeLot.current = false;
        }

        updateSceneFilter();
    }

    function toggleTypeVilla() {
        if(typeVilla.current === false) {
            typeVilla.current = true;
        } else {
            typeVilla.current = false;
        }
        updateSceneFilter();

    }


    const minPrice = useRef(0);
    const maxPrice = useRef(2000000);

    const [minPriceState, setMinPriceState] = useState(0);
    const [maxPriceState, setMaxPriceState] = useState(2000000);


    const onMinPriceChange = (e) => {
        const value = Math.min(e.target.value, maxPrice.current - 500); // Ensure min is always less than max
        minPrice.current = value;
        setMinPriceState(minPrice.current);
        updateSceneFilter();
    };

    const onMaxPriceChange = (e) => {
        const value = Math.max(e.target.value, minPrice.current + 500); // Ensure max is always greater than min
        maxPrice.current = value;
        setMaxPriceState(maxPrice.current);
        updateSceneFilter();
    };

    function toggleWaterfront() {
        if(waterFront.current === true) {
            waterFront.current = false;
        } else {
            waterFront.current = true;
        }

        updateSceneFilter();
    }

    function toggleOpenOceanView() {
        if(openOceanView.current === true) {
            openOceanView.current = false;
        } else {
            openOceanView.current = true;
        }

        updateSceneFilter();
    }

    function toggleBayView() {
        if(bayView.current === true) {
            bayView.current = false;
        } else {
            bayView.current = true;
        }

        updateSceneFilter();
    }

    function resetAllFilters() {
        typeVilla.current = true;

        typeLot.current = true;

        openOceanView.current = false;
        bayView.current = false;
        waterFront.current = false;

        available.current = false;
        notAvailable.current = false;
        sold.current = false;
        reserved.current = false;

        minPrice.current = 0;
        maxPrice.current = 2000000;

        setMinPriceState(0);
        setMaxPriceState(2000000);

        updateSceneFilter();
    }


    async function onItemSelected (item) {
        //console.log('ITEM SELECTED XXX');
        if(item !== null) {
            let itemNames = item.name.split(',');
            if(itemNames.length > 1) {
                if(itemInfoCache.current.hasOwnProperty(itemNames[0])) {

                    //itemInfoCache.current[item.name].media = mediaUrls;

                    //console.log('POPPING UP INFO');
                    const infoList = [];
                    for(let i = 0; i < itemNames.length; i ++) {
                        infoList.push(itemInfoCache.current[itemNames[i]]);
                    }
                    setPopupInfoMulti(infoList);
                    setTooltipVisible(false);
                    setPopupOn(false);
                    setPopupMultiOn(true);
                }
            } else {
                if(itemInfoCache.current.hasOwnProperty(itemNames[0])) {
                    setPopupInfo(itemInfoCache.current[itemNames[0]]);
                    setTooltipVisible(false);
                    setPopupMultiOn(false);
                    setPopupOn(true);

                }
            }

        } else {
            //console.log('error selected  item is null!');
        }
    }




    const [maxPriceSliderVal, setMaxPriceSliderVal] = useState(2000000);
    const [minPriceSliderVal, setMinPriceSliderVal] = useState(0);

    function offsetZoom(v) {

    }

    return (
        <div>
            <div>
            {isLoading ? (
                <div className="loading-spinner-overlay">
                    <img className="loading-spinner-logo" src={logo}/>
                    <img className="loading-spinner-icon" src={iconLoading}/>
                    <p>Loading...</p>
                    {/* Replace this with your spinner component */}
                </div>
            ) : (<></>)}
            </div>

            <div className={'debugxxx'} draggable="false">
                {tooltipVisible && (
                    <div ref={tooltipRef} className="tooltipStyle" style={{ position: "absolute", zIndex: 9999 }}>
                        {tooltipState.current.src && <img src={tooltipState.current.src} alt="Tooltip" />}
                        {tooltipState.current.text}
                    </div>
                )}

                <ThreeAnim ref={threeAnimRef} sceneFilter={sceneFilter} onItemSelected={onItemSelected} onTooltipActivated={onTooltipActivated} projectData={projectData}/>

                <div>
                    {popupOn ? <PopupInfo info={popupInfo} closePopup={()=>{setPopupOn(false)}} /> : <></>}
                    {popupMultiOn ? <PopupInfoMulti infoArray={popupInfoMulti} sceneFilter={sceneFilter} closePopup={()=>{setPopupMultiOn(false)}} /> : <></>}

                </div>

                <div className="App" onClick={()=>{}} draggable="false">
                    <div className={'north-pointer'}>
                        <img src={northPointer} style={{width: '100%', height: '100%'}}/>
                    </div>
                    <div className="zoom-container">
                        <button onClick={()=>{
                            if(threeAnimRef.current !== null) {
                                //threeAnimRef
                                threeAnimRef.current.offsetZoom(-1);
                            }
                        }}>+
                        </button>
                        <span></span>
                        <button onClick={()=>{
                            if(threeAnimRef.current !== null) {
                                //threeAnimRef
                                threeAnimRef.current.offsetZoom(1);
                            }
                        }}>-
                        </button>
                    </div>

                    <div className={isMenuOpen ? 'barMenuBtnOn' : 'barMenuBtnOff'}>
                        <button style={{width:'100%' , height:'100%', background: 'transparent', border: 'none', color: 'white'}} onClick={()=>{
                            setIsMenuOpen(!isMenuOpen);
                        }}>
                            {isMenuOpen ? (">") : ("<")}
                        </button>
                    </div>
                    {isMenuOpen ?
                        (
                    <div onClick={()=>{}} className={`slider-menu`}>
                        <div className="container-logo">
                            <img className="logo" src={logo} alt="Logo"/>
                        </div>
                        <div className="container-type">
                            <span>Select Type</span>
                            <div className="select-type-buttons">
                                <button onClick={toggleTypeVilla} className={typeVilla.current ? 'select-type-button active' : 'select-type-button'}>Villa</button>
                                <button onClick={toggleTypeLot} className={typeLot.current ? 'select-type-button-lot active' : 'select-type-button-lot'}>Lot</button>
                            </div>
                        </div>
                        <div className="container-price">
                            <span className="label">Total Price</span>
                            <div className="container-price-text">
                                <span className="container-price-min">${minPrice.current.toLocaleString()}</span>
                                <span className="container-price-mid">-</span>
                                <span className="container-price-max">${maxPrice.current.toLocaleString()}</span>
                            </div>
                            <div className="range-slider" style={{ '--minValue': minPrice.current, '--maxValue': maxPrice.current }}>
                                <input
                                    type="range"
                                    min={sliderValueMin}
                                    max={sliderValueMax}
                                    step="500"
                                    value={minPriceState}
                                    onChange={onMinPriceChange}
                                    className="slider"
                                    style={{ zIndex: minPriceSliderVal >sliderValueMin ? 1 : 2 }}
                                />

                                <input
                                    type="range"
                                    min={sliderValueMin}
                                    max={sliderValueMax}
                                    step="500"
                                    value={maxPriceState}
                                    onChange={onMaxPriceChange}
                                    className="slider"
                                    style={{ zIndex: maxPriceSliderVal < sliderValueMax ? 2 : 1 }}
                                />
                            </div>
                            <div className="range-values">
                                <span className={"range-values-left"}>${sliderValueMin.toLocaleString()}</span>
                                <span></span>
                                <span className={"range-values-right"}>${sliderValueMax.toLocaleString()}</span>
                            </div>
                        </div>
                        <div className="container-features">
                                <div className="toggle-container">
                                    <div className={waterFront.current ? 'switch active' : 'switch'} onClick={toggleWaterfront} />
                                    <div className="container-features-label">Waterfront</div>
                                </div>
                                <div className="toggle-container">
                                    <div className={openOceanView.current ? 'switch active' : 'switch'} onClick={toggleOpenOceanView} />
                                    <div className="container-features-label">Open Ocean View</div>
                                </div>
                                <div className="toggle-container">
                                    <div className={bayView.current ? 'switch active' : 'switch'} onClick={toggleBayView} />
                                    <div className="container-features-label">Bay View</div>
                                </div>

                        </div>
                        <div className="container-status">
                            <div className="status-title">Status</div>

                            <div className="button-container">
                                <button onClick={toggleAvailable} className={available.current ? 'inline-button active' : 'inline-button'}>Available</button>
                            </div>

                            <div className="button-container">
                                <button onClick={toggleNotAvailable} className={notAvailable.current ? 'inline-button active' : 'inline-button'}>Not Available</button>
                            </div>



                            <div className="button-container">
                                <button onClick={toggleReserved} className={reserved.current ? 'inline-button active' : 'inline-button'}>Reserved</button>
                            </div>

                            <div className="button-container">
                                <button onClick={resetAllFilters} className="inline-button-text">
                                    <span>Reset all filters</span>
                                </button>
                            </div>
                        </div>
                        <div className="container-bottom">

                        </div>
                    </div>) : null }
                </div>
            </div>
        </div>
    );
}

export default App;
